<template>
    <div :class="[
        'session__show_dates_item',
        'session__show_dates_item--expanded'
    ]">
        <div class="session__show_dates_item_content">
            <div class="session__show_dates_item_content_title">{{ dateDate }}</div>
            <div class="session__show_dates_item_content_details">
                <div class="session__show_dates_item_content_details_list">
                    <ul>
                        <li>
                            <div class="columns is-vcentered">
                                <div class="column is-narrow">
                                    <div class="session__show_dates_item_content_details_list_icon">
                                        <v-icon name="clock"/>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="session__show_dates_item_content_details_list_time">{{ dateTime }}</div>
                                </div>
                            </div>
                        </li>
                        <template v-if="dateTrainers.length">
                            <li>
                                <div class="columns is-vcentered">
                                    <div class="column is-narrow">
                                        <div class="session__show_dates_item_content_details_list_icon">
                                            <v-icon name="clipboard"/>
                                        </div>
                                    </div>
                                    <div class="column">
                                        <ul class="session__show_dates_item_content_details_list_trainers">
                                            <li
                                                :class="trainer.isActive === false ? 'session__show_dates_item_content_details_list_trainers--error' : ''"
                                                :key="index"
                                                v-for="(trainer, index) in dateTrainers"
                                            >{{ trainer.name }}{{ trainer.isActive === false ? ` (Inactive)` : '' }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </template>
                        <li>
                            <div class="columns is-vcentered">
                                <div class="column is-narrow">
                                    <div class="session__show_dates_item_content_details_list_icon">
                                        <v-icon name="map-pin"/>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="session__show_dates_item_content_details_list_location">{{ dateLocation }}
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <template v-if="sessionSessionType !== 'virtual' || sessionSessionType === 'virtual' && dateVirtualAccessDetails.length">
                    <div class="session__show_dates_item_content_details_location">
                        <div class="session__show_dates_item_content_details_location_expand">
                            <component-button
                                :name="`session-show-datesitem-expand-${sessionIndex}`"
                                :icon="true"
                                :icon-align="'right'"
                                :icon-name="isExtraLocationActive ? 'chevron-down' : 'chevron-right'"
                                :text="true"
                                :theme="'primary'"
                                :underline="true"
                                :size="'tiny'"
                                @click="toggleExtraLocation"
                            >{{ sessionSessionType !== 'virtual' ? 'Venue details' : 'View access details' }}
                            </component-button>
                        </div>
                        <template v-if="sessionSessionType !== 'virtual'">
                            <template v-if="isVenueRequestPending">
                                <component-loading></component-loading>
                            </template>
                            <div v-show="!isVenueRequestPending" class="session__show_dates_item_content_details_location_venue">
                                <template v-if="isExtraLocationActive">
                                    <component-title
                                        :class="'session__show_dates_item_content_details_location_venue_name'"
                                        :size="'small'"
                                    >{{ locationVenueName }}
                                    </component-title>
                                    <div
                                        v-if="locationVenueImage"
                                        class="session__show_dates_item_content_details_location_venue_thumbnail"
                                    >
                                        <component-thumbnail
                                            :id="locationVenueImage"
                                            :alt="locationVenueName"
                                            :thumbnail-size="'small'"
                                            :allow-preview="true"
                                            :pop-image-size="'original'"
                                        ></component-thumbnail>
                                    </div>
                                </template>
                                <div class="session__show_dates_item_content_details_location_venue_location">
                                    <div class="columns is-gapless">
                                        <div class="column">
                                            <div class="session__show_dates_item_content_details_location_venue_location_address">
                                                <div class="session__show_dates_item_content_details_location_venue_location_address_text">
                                                    <component-address :address="dateVenueAddress"/>
                                                </div>
                                                <template v-if="user.isEventCoordinator() || user.isInfrastructureManager()">
                                                    <div class="session__show_dates_item_content_details_location_venue_location_address_link">
                                                        <router-link
                                                            :to="{ name: 'ebs-venue-show', params: { id: dateVenue.venueId } }"
                                                        >{{ $t('ebs.sessions.show.buttons.moreDetails') }}
                                                        </router-link>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="column is-narrow">
                                            <div class="session__show_dates_item_content_details_location_venue_location_map">
                                                <component-map
                                                    :address="dateVenueAddress"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="isExtraLocationActive">
                                    <component-title
                                        :class="'session__show_dates_item_content_details_location_room_title'"
                                        :size="'small'"
                                    >Room details
                                    </component-title>
                                    <div
                                        v-if="locationRoomImage"
                                        class="session__show_dates_item_content_details_location_room_thumbnail"
                                    >
                                        <component-thumbnail
                                            :id="locationRoomImage"
                                            :alt="locationRoomName"
                                            :thumbnail-size="'small'"
                                            :allow-preview="true"
                                            :pop-image-size="'original'"
                                        ></component-thumbnail>
                                    </div>
                                    <div class="session__show_dates_item_content_details_location_room_name">{{ locationRoomName }}</div>
                                    <div
                                        v-if="locationRoomDescription"
                                        class="session__show_dates_item_content_details_location_room_description"
                                    >
                                        <component-text>
                                            {{ locationRoomDescription }}
                                        </component-text>
                                    </div>
                                    <div class="session__show_dates_item_content_details_location_room_contact">
                                        <component-title
                                            :class="'session__show_dates_item_content_details_location_room_contact_title'"
                                            :size="'small'"
                                        >Contact details
                                        </component-title>
                                        <div
                                            v-if="locationVenueContactPhone"
                                            class="session__show_dates_item_content_details_location_room_contact_phone"
                                        >
                                            {{ locationVenueContactPhone }}
                                        </div>
                                        <div
                                            v-if="locationVenueContactEmail"
                                            class="session__show_dates_item_content_details_location_room_contact_email"
                                        >
                                            {{ locationVenueContactEmail }}
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-else>
                            <template v-if="isExtraLocationActive">
                                <div
                                    class="session__show_dates_item_content_details_virtualaccessdetails"
                                    v-html="dateVirtualAccessDetails"
                                ></div>
                            </template>
                        </template>
                    </div>
                </template>
                <template
                    v-if="user.isOnlyLearner() && (dateUserAttendenceDataAttendence || dateUserAttendenceDataAbsentReason)">
                    <div class="session__show_dates_item_content_details_user">
                        <ul class="session__show_dates_item_content_details_user_list">
                            <template v-if="dateUserAttendenceDataAttendence">
                                <li class="session__show_dates_item_content_details_user_list_item session__show_dates_item_content_details_user_list_item--attendence">
                                    <div class="columns">
                                        <div class="column">
                                            <div class="session__show_dates_item_content_details_user_list_item_label">{{ $t('ebs.sessions.show.text.attendance') }}</div>
                                        </div>
                                        <div class="column has-text-right">
                                            <div class="session__show_dates_item_content_details_user_list_item_value">
                                                <component-status :status="dateUserAttendenceDataAttendence"/>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </template>
                            <template v-if="dateUserAttendenceDataAbsentReason">
                                <li class="session__show_dates_item_content_details_user_list_item session__show_dates_item_content_details_user_list_item--attendence">
                                    <div class="columns">
                                        <div class="column">
                                            <div class="session__show_dates_item_content_details_user_list_item_label">{{ $t('ebs.sessions.show.text.reason') }}</div>
                                        </div>
                                        <div class="column has-text-right">
                                            <div class="session__show_dates_item_content_details_user_list_item_value">
                                                {{ dateUserAttendenceDataAbsentReason }}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </template>
                <template v-if="sessionSessionType === 'virtual' && (userHasActiveBooking || user.isSessionTrainer(sessionTrainers))">
                    <component-button
                        :align="'right'"
                        :name="'session-show-dates-item-access-button'"
                        :to-external="dateMeetingLink"
                        :target="true"
                    >Join online
                    </component-button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentMap from '@/components/default/shared/ComponentMap'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentAddress from '@/components/default/shared/ComponentAddress'
import { User } from '@/User'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentThumbnail from '@/components/default/shared/ComponentThumbnail'
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentText from '@/components/default/shared/ComponentText'

export default {
  components: {
    ComponentText,
    ComponentTitle,
    ComponentLoading,
    ComponentThumbnail,
    ComponentButton,
    ComponentAddress,
    ComponentStatus,
    ComponentMap
  },
  name: 'session-show-dates-item',
  data () {
    return {
      user: new User(),
      isExtraLocationActive: false,
      isVenueRequestPending: false
    }
  },
  props: {
    session: {
      type: [Array, Object],
      default: () => {
      },
      required: true
    },
    sessionIndex: {
      type: [Number, String],
      default: 1,
      required: true
    },
    sessionCount: {
      type: [Number, String],
      default: 1,
      required: true
    }
  },
  computed: {
    sessionSessionType () {
      return this.$store.getters.getSessionSessionType
    },
    sessionTrainers: function () {
      return this.$store.getters.getSessionTrainers
    },
    dateId: function () {
      return this.session.id
    },
    dateTitle: function () {
      return `Date ${this.sessionIndex} of ${this.sessionCount}`
    },
    dateDatetimeStart () {
      return this.session.datetimeStart
    },
    dateDatetimeEnd () {
      return this.session.datetimeEnd
    },
    dateDate: function () {
      const dateStart = this.session.dateStartLocal
      return this.toLocaleDateTime(dateStart)
    },
    dateTime: function () {
      const date = this.session.date
      const timeStart = date + 'T' + this.session.timeStartLocal
      const timeEnd = date + 'T' + this.session.timeEndLocal

      return date ? this.toLocaleTime(timeStart) + ' - ' + this.toLocaleTime(timeEnd) : false
    },
    dateTrainers: function () {
      return this.sortByKey(this.session.trainers, 'name')
    },
    dateVenue: function () {
      return this.session.venue
    },
    dateVenueId: function () {
      return this.session.venue.venueId
    },
    dateMeetingLink () {
      return this.session.meetingLink
    },
    dateVenueAddress: function () {
      return this.session.venue.address
    },
    dateRoom: function () {
      return this.session.room
    },
    datePlatform () {
      return this.session.platform
    },
    dateVirtualAccessDetails () {
      return this.session.virtualAccessDetails
    },
    dateRoomId: function () {
      return this.session.roomId
    },
    dateLocation: function () {
      const venue = this.dateVenue.name
      const room = this.dateRoom.name
      if (this.sessionSessionType === 'virtual') {
        return this.datePlatform + ' meeting'
      } else {
        if (venue && room) {
          return `${venue} - ${room}`
        }
      }
      return false
    },
    dateUserAttendenceDataAttendence: function () {
      if (this.session.userAttendenceData) {
        return this.session.userAttendenceData.attendance
      }
      return false
    },
    dateUserAttendenceDataAbsentReason: function () {
      if (this.session.userAttendenceData) {
        return this.session.userAttendenceData.absentReason
      }
      return false
    },
    userHasActiveBooking () {
      return this.$store.getters.getSessionHasUserActiveBooking
    },
    //
    locationVenueName () {
      return this.$store.getters.getVenueName
    },
    locationVenueContactPhone () {
      return this.$store.getters.getVenueContactPhone
    },
    locationVenueContactEmail () {
      return this.$store.getters.getVenueContactEmail
    },
    locationVenueImage () {
      const images = this.$store.getters.getVenueImages
      return images.length ? images[0].fileId : ''
    },
    locationRoom () {
      const rooms = this.$store.getters.getVenueRooms
      return rooms ? (rooms.length ? rooms.find(obj => obj.id === this.dateRoomId) : {}) : {}
    },
    locationRoomName () {
      const room = this.locationRoom
      return room ? this.locationRoom.name : ''
    },
    locationRoomDescription () {
      const room = this.locationRoom
      return room ? this.locationRoom.description : ''
    },
    locationRoomImage () {
      const room = this.locationRoom
      const images = room ? this.locationRoom.files : []
      return images ? (images.length ? images[0].fileId : '') : ''
    }
  },
  methods: {
    closeExtraLocation () {
      this.isExtraLocationActive = false
    },
    toggleExtraLocation () {
      const value = !this.isExtraLocationActive
      this.$eventBus.$emit('session-dates-item-close-extra-location')
      this.isExtraLocationActive = value
      if (value && this.sessionSessionType !== 'virtual') {
        this.getVenue()
      }
    },
    getVenue () {
      this.isVenueRequestPending = true
      this.$store.dispatch('getVenue', this.dateVenueId).finally(() => {
        this.isVenueRequestPending = false
      })
    }
  },
  mounted () {
    this.$eventBus.$on('session-dates-item-close-extra-location', this.closeExtraLocation)
  }
}
</script>

<style lang="scss">
    @import '~@/assets/scss/components/ebs/sessions/sessionshowdatesitems';
</style>
